@if (navegando$ | async) {
<div class="barra-navegacao" role="progressbar" aria-label="Carregando a página"></div>
}
<router-outlet />
